import {FlexRow, Modal, Text} from '@forecast-it/design-system';
import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {MODAL_TYPE, showModal} from '../../../shared/components/modals/generic_modal_conductor';
import {ModalProps} from '../../../shared/components/modals/types';

type DeleteCustomFieldConfirmationModalProps = {
	onDelete: () => void;
	customFieldName: string;
};

export const showDeleteCustomFieldConfirmationModal = (props: DeleteCustomFieldConfirmationModalProps): void => {
	showModal({
		type: MODAL_TYPE.DELETE_CUSTOM_FIELD_CONFIRMATION_MODAL,
		...props,
	});
};

export const DeleteCustomFieldConfirmationModal = ({
	closeModal,
	onDelete,
	customFieldName,
}: ModalProps<DeleteCustomFieldConfirmationModalProps>): JSX.Element => {
	const intl = useIntl();

	const handleDelete = () => {
		onDelete();
		closeModal();
	};

	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal} closeOnInteractOutside={false}>
			<Modal.Title>{intl.formatMessage({id: 'settings.custom-fields.delete_modal.delete_custom_field'})}</Modal.Title>
			<Modal.Content>
				<Text>
					{intl.formatMessage(
						{id: 'settings.custom-fields.delete_modal.delete_confirmation_message'},
						{name: customFieldName}
					)}
				</Text>
				<FlexRow>
					<Modal.PrimaryFooterButton onPress={handleDelete} dataCy="delete-custom-field">
						{intl.formatMessage({id: 'settings.custom-fields.delete_modal.delete_custom_field'})}{' '}
					</Modal.PrimaryFooterButton>
					<Modal.SecondaryFooterButton onPress={closeModal} dataCy="cancel">
						<FormattedMessage id="common.cancel" />
					</Modal.SecondaryFooterButton>
				</FlexRow>
			</Modal.Content>
		</Modal>
	);
};
